export enum ChangePasswordMode {
  ChangePassword = 'ChangePassword',
  CompleteNewPassword = 'CompleteNewPassword',
  ForgotPassword = 'ForgotPassword',
}
